import React, { useState } from 'react';
import '../css/mpvideo.css'

const MpVideo = () => {
  const [play, setPlay] = useState(false);

  return (
    <div className="mp-video-section">
      <div className="mp-video-container">
        {!play ? (
          <div className="video-thumbnail">
            <h2 className="video-title">Take a Video Tour</h2>
            <button className="play-button" onClick={() => setPlay(true)}>
              <i class="fa-regular fa-circle-play"></i>
            </button>
          </div>
        ) : (
          <iframe
            className="video-frame"
            src="https://www.youtube.com/embed/lH88jD_I_VI?autoplay=1"
            title="YouTube video player"
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen
          ></iframe>
        )}
      </div>
    </div>

  );
};

export default MpVideo;
